// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"right__wrap--eFhZf"};